module.exports = __webpack_public_path__ + "static/use-browser-extension-tablet-bae82a6dcf40690e871caffe86e5eb1b.png";